<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="dedication">For Joanna Russ, Luise White,</p>
<p class="noind">and Iva Hacker-Delany</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-dedication.vue?1eadb5ab